import { createActionGroup, props } from '@ngrx/store';
import { VideoSearchResultsPayload } from './models/video-search.models';

export const VideoSearchActions = createActionGroup({
  source: 'Video Search',
  events: {
    'Handle Search Results': props<{ payload: VideoSearchResultsPayload }>(),
    'Show Link': props<{ reason?: string }>(),
    'Show Link After Speech': props<{ reason?: string }>(),
    'Hide Link': props<{ reason?: string }>(),
    'Clear Results': props<{ reason?: string }>(),
  }
});
